import React, { memo } from "react";
import { Box, Typography } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

interface PieDataset {
  label: string;
  data: number[];
  backgroundColor?: string[];
}

interface GenericPieChartProps {
  title: string;
  labels: string[];
  datasets: PieDataset[];
  height?: number | string;
  options?: any;
}

const GenericPieChart: React.FC<GenericPieChartProps> = ({
  title,
  labels,
  datasets,
  height = 300,
  options,
}) => {
  const hasData = datasets.some(
    (ds) => ds.data.length > 0 && ds.data.some((v) => v !== 0)
  );

  if (!hasData) {
    return (
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 2,
          boxShadow: 1,
          textAlign: "center",
        }}
      >
        <Typography
          fontWeight={600}
          mb={1}
          sx={{ textDecoration: "underline", textAlign: "left" }}
        >
          {title}
        </Typography>
        <Typography color="textSecondary" sx={{ textAlign: "left" }}>
          No Records Found
        </Typography>
      </Box>
    );
  }

  const pieData = { labels, datasets };

  const pieOptions = options || {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" as const },
      tooltip: { enabled: true },
      datalabels: {
        color: "#fff",
        font: { weight: "bold" as const, size: 12 },
        formatter: (value: number) => value.toString(),
      },
    },
  };

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: 2,
        p: 2,
        boxShadow: 1,
      }}
    >
      <Typography fontWeight={600} mb={1} sx={{ textDecoration: "underline", textAlign: "left" }}>
        {title}
      </Typography>
      <Box sx={{ height }}>
        <Pie data={pieData} options={pieOptions} />
      </Box>
    </Box>
  );
};

export default memo(GenericPieChart);
